import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { MessageTemplatesResponse } from '@chatapp-inbox/shared';
import { listMessageTemplates } from '../../api';

/** Fora de `['session']`: o logout e a troca de conta descartam a lista junto com o resto. */
export const templatesKey = ['message-templates'] as const;

/**
 * Os modelos aprovados. O servidor consulta a Meta (e guarda a lista por 1 minuto), então a interface
 * também não pergunta mais de uma vez por minuto. Em falha `data` fica indefinido e quem usa decide
 * o que mostrar. Com `lineId`, os modelos da conta desse número (cada conta tem os seus); sem ele, os
 * da conta principal (basta para saber SE há modelos).
 */
export function useTemplates(lineId?: string): UseQueryResult<MessageTemplatesResponse> {
  return useQuery({
    queryKey: lineId ? [...templatesKey, lineId] : templatesKey,
    queryFn: ({ signal }) => listMessageTemplates(signal, lineId),
    staleTime: 60_000,
  });
}

/**
 * O provedor tem modelos? Só a resposta do servidor (`supported: true`) diz que sim: enquanto carrega, ou
 * se a consulta falhou, "Nova conversa" e "Enviar modelo" não aparecem (não prometem o que pode não
 * existir). A consulta se refaz sozinha (foco da janela, nova abertura da lista).
 */
export const templatesAvailable = (data: MessageTemplatesResponse | undefined): boolean =>
  data?.supported === true;
